//  @vendors
import { useState, useRef } from "react";
//  @configurations
import { getPopoverPosition } from "../config/brokerCryptoTooltip.configurations";

const CryptoTooltipHook = () => {
    const [active, setActive] = useState(false);
    const [popoverPosition, setPopoverPosition] = useState({
      left: 0,
      top: 0,
    });
    const tooltipRef = useRef(null);

    const showTooltip = (event) => {
      if (event) {
        setPopoverPosition(getPopoverPosition({ event, tooltip: tooltipRef }));
      }
      setActive(true);
    };

    const hideTooltip = () => {
      setActive(false);
    };

    return {
        active,
        hideTooltip,
        popoverPosition,
        showTooltip,
        tooltipRef,
    };
};

export { CryptoTooltipHook };
